function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Button } from '../../../components/button';
import { Divider } from '../../../components/divider';
import { CheckGroup } from '../../../components/check-group';
import { RadioGroup } from '../../../components/radio-group';
export var FilterPanel = function FilterPanel(props) {
  var title = props.title,
      multiple = props.multiple,
      _props$datasource = props.datasource,
      datasource = _props$datasource === void 0 ? [] : _props$datasource,
      value = props.value,
      onValueChange = props.onValueChange;
  var validValue = value;

  if (multiple && value != null && !Array.isArray(value)) {
    console.warn("title \u4E3A ".concat(title, " \u7684\u7B5B\u9009\u9879\uFF0C\u7B5B\u9009\u503C\u5E94\u8BE5\u662F\u6570\u7EC4\u6216null"));
    validValue = [];
  } else if (!multiple && Array.isArray(value)) {
    console.warn("title \u4E3A ".concat(title, " \u7684\u7B5B\u9009\u9879\uFF0C\u7B5B\u9009\u503C\u4E0D\u5E94\u8BE5\u662F\u6570\u7EC4"));
    validValue = '';
  }

  var _useState = useState(validValue !== null && validValue !== void 0 ? validValue : multiple ? [] : ''),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var onValueChangeCallback = useRefCallback(onValueChange);
  var confirmHandler = useRefCallback(function () {
    onValueChangeCallback(currentValue !== null && currentValue !== void 0 ? currentValue : multiple ? [] : '');
  });
  var resetHandler = useRefCallback(function () {
    return onValueChangeCallback(null);
  });
  var resetDisabled = useCallback(function () {
    return multiple ? currentValue.length === 0 : currentValue === '';
  }, [currentValue, multiple]);
  var cls = usePrefixCls('table-filter-panel');
  var resetText = useLocale('table.filter.reset');
  var confirmText = useLocale('table.filter.confirm');
  return React.createElement("div", {
    className: cls
  }, multiple ? React.createElement(CheckGroup, {
    value: currentValue,
    onValueChange: setCurrentValue,
    className: "panel-body"
  }, datasource.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return React.createElement(CheckGroup.Checkbox, {
      key: value,
      value: value
    }, label);
  })) : React.createElement(RadioGroup, {
    value: currentValue,
    onValueChange: setCurrentValue,
    className: "panel-body"
  }, datasource.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return React.createElement(RadioGroup.Radio, {
      key: value,
      value: value
    }, label);
  })), React.createElement(Divider, null), React.createElement("div", {
    className: "panel-footer"
  }, React.createElement(Button, {
    type: "text-primary",
    className: "btn-reset",
    disabled: resetDisabled(),
    size: "xs",
    onClick: resetHandler
  }, resetText), React.createElement(Button, {
    type: "primary",
    size: "xs",
    className: "btn-confirm",
    onClick: confirmHandler
  }, confirmText)));
};